var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[(_vm.hasLabel)?_vm._t("label"):_c('span',[_vm._v(_vm._s(_vm.label))])],2),_vm._v(" "),(_vm.hasInput)?_vm._t("input"):_c('a-input',{model:{value:(_vm.trawlValue),callback:function ($$v) {_vm.trawlValue=$$v},expression:"trawlValue"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }